<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title font-weight-bold" id="exampleModalLabel1">
      ¿Esta seguro que desea aprobar este caso?
    </h4>
    <button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      mat-dialog-close
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <div class="row">
      <div class="col-12 col-md-6">
        <button mat-dialog-close="true" class="btn btn-block btn-success">
          Aceptar
          <i class="mdi mdi-check-circle ml-2"></i>
        </button>
      </div>
      <div class="col-12 col-md-6">
        <button mat-dialog-close="false" class="btn btn-block btn-danger">
          Cancelar <i class="mdi mdi-close-circle ml-2"></i>
        </button>
      </div>
    </div>
  </div>
</div>
